export default {
  prefix: {
    id: '',
    nameLocal: '',
    nameEng: '',
  },
  prefixes: [],
  processing: false,
  error: null,
  success: null,
}



